<mat-form-field *ngIf="control" appearance="outline" [floatLabel]="floatLabelType" class="custom__class-select-filters">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <input type="text" [placeholder]="placeholder" matInput [matAutocomplete]="auto" [matAutocomplete]="auto"
    #triggerC="matAutocompleteTrigger" #inputRef [formControl]="control">
  <mat-icon matSuffix *ngIf="!isOpenPanel && !control?.value" (click)="openOrClosePanel($event, triggerC)"
    fontSet="material-icons-outlined">keyboard_arrow_up</mat-icon>
  <mat-icon matSuffix *ngIf="isOpenPanel && !control?.value" (click)="openOrClosePanel($event, triggerC)"
    fontSet="material-icons-outlined">keyboard_arrow_down</mat-icon>
  <mat-icon class="material-symbols-rounded fill" matSuffix *ngIf="control?.value" (click)="onClear()">cancel</mat-icon>

  <mat-autocomplete [class]="'custom_panel_with-'+selectOutlineWithPanel" autoActiveFirstOption #auto="matAutocomplete"
    (closed)="isOpenPanel = true" (opened)="isOpenPanel = false" (optionSelected)="onSelect($event.option.value)"
    [displayWith]="displayFn" [panelWidth]="panelWidth">
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">{{ displayFn(option) }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>